import { DatePipe } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { userListModel } from '../../../models/userModel/userListModel';
import { agendaListModel } from '../../../models/agendaModel/agendaListModel';
import { AgendaService } from './../../../core/services/agenda.service';
import { ModalNotificationComponent } from '../modal-notification/modal-notification.component';
import { GlobalComponents } from '../global-constants';

@Component({
  selector: 'app-modal-meeting',
  templateUrl: './modal-meeting.component.html',
  styleUrls: ['./modal-meeting.component.scss']
})

export class ModalMeetingComponent implements OnInit {
  public usuario: userListModel[];
  public idMeet: number;
  public agen: agendaListModel[];
  public idiom: string;
  public topicMeeting: string;
  public dateMeeting: string;
  columnas: string[] = ['userName'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  languaje: string = "Español";

  constructor(@Inject(MAT_DIALOG_DATA) data, 
              private dialog: MatDialog,
              public datepipe: DatePipe,
              public dialogRef: MatDialogRef<ModalMeetingComponent>,
              private serviceAgenda: AgendaService)
  { 
    this.usuario = data.colec;
    this.idMeet = data.valor;
    this.topicMeeting = data.topicMeeting;
    this.dateMeeting = this.datepipe.transform(data.dateMeeting, 'dd/MMMM/yyyy');
  }

  stbDisplayedColumns = [
    "userName",
  ];

  ngOnInit(): void {    
    this.idiom = JSON.parse(localStorage.getItem('languaje')).name;
    
    this.serviceAgenda.getAgendaItem(this.idMeet).subscribe(resp => {
      const us=[];
      resp.agenda.forEach(element => {
        us.push({
          agendaItemid: element.agendaItemid,
          meetingId: element.meetingId,
          topicEn: element.topicEn,
          topicEs: element.topicEs         
        });
      });
      this.agen = us;
    }, (error) => {
      this.notificationModal(GlobalComponents.notSuccess);
    })
  }
  
  closeModal()
  {
    this.dialogRef.close();
  }

  notificationModal(message: string){
    const dialogConfig = new MatDialogConfig();    
    dialogConfig.data = {
      message: message,
      valor:10
    }
    const modalRef = this.dialog.open(ModalNotificationComponent, dialogConfig);
  }
}
